import {
  EMPLOYER_ONBOARDING_ARRIVED_CREATE_ACCOUNT,
  EMPLOYER_ONBOARDING_LOGGED_IN,
  EMPLOYER_ONBOARDING_ACCOUNT_CREATED,
  EMPLOYER_ONBOARDING_EXIT_CREATE_ACCOUNT,
  EMPLOYER_ONBOARDING_ARRIVED_ACCOUNT_DETAILS,
  EMPLOYER_ONBOARDING_SUBMIT_ACCOUNT_DETAILS,
  EMPLOYER_ONBOARDING_EXIT_ACCOUNT_DETAILS,
  EMPLOYER_ONBOARDING_CONTINE_TO_EMPLOYER_CENTER,
  EMPLOYER_ONBOARDING_EXIT_CONFIRMATION,
  EMPLOYER_ONBOARDING_EXIT_SELECT_SERVICES,
} from '../constants/reportableEventConstants';
import reporter from '../reporter';

const reportOnboardingArrivedCreateAccount = () => {
  reporter.report(EMPLOYER_ONBOARDING_ARRIVED_CREATE_ACCOUNT, {});
};

const reportOnboardingLoggedIn = (method) => {
  reporter.report(EMPLOYER_ONBOARDING_LOGGED_IN, {
    method,
  });
};

const reportOnboardingAccountCreated = (method) => {
  reporter.report(EMPLOYER_ONBOARDING_ACCOUNT_CREATED, {
    method,
  });
};

const reportOnboardingExitCreateAccount = () => {
  reporter.report(EMPLOYER_ONBOARDING_EXIT_CREATE_ACCOUNT, {});
};

const reportOnboardingArrivedAccountDetails = () => {
  reporter.report(EMPLOYER_ONBOARDING_ARRIVED_ACCOUNT_DETAILS, {});
};

const reportOnboardingSubmitAccountDetails = (openingsPerYear, organizationId, organizationName) => {
  reporter.report(EMPLOYER_ONBOARDING_SUBMIT_ACCOUNT_DETAILS, {
    openingsPerYear,
    organizationId,
    organizationName,
  });
};

const reportOnboardingExitAccountDetails = () => {
  reporter.report(EMPLOYER_ONBOARDING_EXIT_ACCOUNT_DETAILS, {});
};

const reportOnboardingExitSelectServices = (organizationId) => {
  reporter.report(EMPLOYER_ONBOARDING_EXIT_SELECT_SERVICES, {
    organizationId,
  });
};

const reportOnboardingContinueToEmployerCenter = (organizationId) => {
  reporter.report(EMPLOYER_ONBOARDING_CONTINE_TO_EMPLOYER_CENTER, {
    organizationId,
  });
};

const reportOnboardingExitConfirmation = (organizationId) => {
  reporter.report(EMPLOYER_ONBOARDING_EXIT_CONFIRMATION, {
    organizationId,
  });
};


export {
  reportOnboardingArrivedCreateAccount,
  reportOnboardingLoggedIn,
  reportOnboardingAccountCreated,
  reportOnboardingExitCreateAccount,
  reportOnboardingArrivedAccountDetails,
  reportOnboardingSubmitAccountDetails,
  reportOnboardingExitAccountDetails,
  reportOnboardingContinueToEmployerCenter,
  reportOnboardingExitConfirmation,
  reportOnboardingExitSelectServices,
};

export default {
  reportOnboardingArrivedCreateAccount,
  reportOnboardingLoggedIn,
  reportOnboardingAccountCreated,
  reportOnboardingExitCreateAccount,
  reportOnboardingArrivedAccountDetails,
  reportOnboardingSubmitAccountDetails,
  reportOnboardingExitAccountDetails,
  reportOnboardingContinueToEmployerCenter,
  reportOnboardingExitConfirmation,
  reportOnboardingExitSelectServices,
};
